import { useEffect, useState } from "react";           // add useState
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import Navigation from "@/components/shared/Navigation";
import Footer from "@/components/shared/Footer";
import BlogCard from "./BlogCard";
import { blogs } from "./blogs";

const BlogsPage = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("");

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, []);

  const scrollToSection = (sectionId) => {             // add this
    navigate(`/?section=${sectionId}`);
  };

  return (
    <div>
      <Navigation onSectionClick={scrollToSection}              // pass props
        activeTab={activeTab}
        setActiveTab={setActiveTab} />

      <div className="min-h-screen bg-[#F8F9FA]">
        {/* Header */}
        <div
          className="py-20 px-6 md:px-12"
          style={{
            background: "linear-gradient(135deg, #0A2725 0%, #0F3D3A 100%)",
          }}
        >
          <div className="max-w-7xl mx-auto">
            <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4">
              Our Blogs
            </h1>
            <p className="text-white/70 text-lg max-w-3xl">
              Insights, tips, and knowledge to help you live healthier
            </p>
          </div>
        </div>

        {/* Blog Cards */}
        <section className="py-16 px-6 md:px-12">
          <div className="max-w-7xl mx-auto grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {blogs.map((blog, i) => (
              <BlogCard key={i} blog={blog} />
            ))}
          </div>
        </section>
      </div>

      <Footer onSectionClick={scrollToSection} setActiveTab={setActiveTab} />
    </div>
  );
};

export default BlogsPage;